module.exports = __webpack_public_path__ + "static/img/wx.ac0761b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/wx.jpg
// module id = zR3R
// module chunks = 202